<template>
  <div class="plan">
    <el-dialog :title="`${edit_id == 0 ? '新增' : '编辑'}监测方案`"
               :visible.sync="dialogVisible"
               width="992px"
               :before-close="handleClose">
      <div class="main scroll-auto">
        <div class="form">
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-form-item label="方案名称："
                          prop="name">
              <el-input v-model="ruleForm.name"
                        clearable
                        class="w400"
                        placeholder="请输入方案名称"></el-input>
            </el-form-item>
            <el-form-item label="执行类型："
                          prop="run_type">
              <el-radio-group v-model="ruleForm.run_type">
                <el-radio label="1">即时</el-radio>
                <!-- <el-radio label="2">定时</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="平台："
                          v-if="type == 'product'">
              <p> <span v-for="(item,index) in platformlist" :key="index">{{item}} </span> </p>
            </el-form-item>
            <el-form-item label="采集选项："
                          prop="crawl_type">
              <el-radio-group v-model="ruleForm.crawl_type">
                <el-radio label="1">计算折扣价</el-radio>
                <el-radio label="2">按面价计算</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="subtitle">
              <h4>产品</h4>
              <div class="btn">
                <el-button type="primary"
                           size="small"
                           @click="createProduct">添 加</el-button>
                             <el-popconfirm title="确定删除吗？"
                                   @confirm="tableData = []">
                      <el-button slot="reference"
                                 type="danger"
                                  size="small"
                                >全部删除</el-button>
                    </el-popconfirm>
               <!--  <el-button type="danger"
                           size="small"
                           @click="tableData = []">全部删除</el-button> -->
              </div>
            </div>
            <div class="table">
              <el-table :data="tableData"
                        style="width: 100%"
                        border>
                <el-table-column type="index"
                                 width="60"
                                 label="序号"
                                 align="center"> </el-table-column>
                <el-table-column align="center"
                                 prop="name"
                                 label="商品名称"
                                 show-overflow-tooltip=""
                                 v-if="type == 'product'">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.name"
                              v-if="!row.isEdit"></el-input>
                    <p v-else>{{ row.name }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 prop="url"
                                 label="SKU"
                                 show-overflow-tooltip=""
                                 v-else>
                  <template slot-scope="{ row }">
                    <el-input v-model="row.url"
                              v-if="!row.isEdit"></el-input>
                    <p v-else>{{ row.url }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 prop="price_gov"
                                 label="政府价格 (元)">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.price_gov"
                              v-if="!row.isEdit"
                              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
                    <p v-else>{{ row.price_gov || "-" }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 prop="price_top"
                                 label="上限价格 (元)">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.price_top"
                              v-if="!row.isEdit"
                              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
                    <p v-else>{{ row.price_top || "-" }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 prop="price_bottom"
                                 label="下限价格 (元)">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.price_bottom"
                              v-if="!row.isEdit"
                              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
                    <p v-else>{{ row.price_bottom || "-" }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 prop="price_guiding"
                                 label="指导价格 (元)">
                  <template slot-scope="{ row }">
                    <el-input v-model="row.price_guiding"
                              v-if="!row.isEdit"
                              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
                    <p v-else>{{ row.price_guiding || "-" }}</p>
                  </template>
                </el-table-column>
                <el-table-column align="center"
                                 label="操作">
                  <template slot-scope="{ row }">
                    <div class="link">
                      <el-link type="primary"
                               @click="changeItem(row)">{{ !row.isEdit ? "确定" : "编辑" }}</el-link>
                      <el-link type="danger"
                               @click="deleteItem(row)">删除</el-link>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <p>注：如不设置限价，系统不判断是否有低价</p>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="onSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      dialogVisible: false,
      ruleForm: {
        name: "",
        plan_type: 1,
        run_type: "1",
        crawl_type: "1",
      },
      rules: {
        name: [{ required: true, message: "请输入方案名称", trigger: "blur" }],
        run_type: [{ required: true, message: "请选择执行类型", trigger: "change" }],
        crawl_type: [{ required: true, message: "请选择采集选项", trigger: "change" }],
      },
      tableData: [],
      edit_id: 0,
      platformlist:[]
    };
  },
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  methods: {
    ...mapActions({
      consoleplanCreate: "detect/consoleplanCreate",
      consoleplanDetail: "detect/consoleplanDetail",
      consoleproductEdit: "detect/consoleproductEdit",
      platform: "detect/platform",
    }),
    getplatform () {
      let params = {
        token: this.getToken,
      };
      this.platform(params).then(({ data }) => {
        this.platformlist=[]
        if (data.code == 1) {
          data.data.forEach(el=>{
            console.log(el,'el')
             this.platformlist.push(el.name)
          })
          
       console.log(data,'data----')

        } else {
          this.$message.error(data.msg);
        }
      });
    },
    getDetail (id) {
      this.edit_id = id;
      let params = {
        token: this.getToken,
        id,
      };
      this.consoleplanDetail(params).then(({ data }) => {
        if (data.code == 1) {
          let { name, run_type, product_list, crawl_type } = data.data;
          this.ruleForm = {
            name,
            run_type,
            crawl_type,
          };
          if (this.type == "product") {
            this.ruleForm.plan_type = 1;
          } else {
            this.ruleForm.plan_type = 2;
          }
          product_list.forEach((item) => (item.isEdit = true));
          this.tableData = product_list;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    changeItem (row) {
      if (!row.isEdit) {
        if (this.type == "product") {
          if (row.name == "") {
            return this.$message.warning("请填写商品名称！");
          }
        } else {
          if (row.url == "") {
            return this.$message.warning("请填写URL！");
          }
        }
      }
      row.isEdit = !row.isEdit;
    },
    deleteItem (row) {
      this.tableData = this.tableData.filter((item) => row != item);
    },
    createProduct () {
      if (this.tableData.length >= 100) {
        return this.$message.warning("已达到最大上限100条");
      }
      let obj = {
        price_top: "", //价格上限
        price_bottom: "", //价格下限
        price_gov: "", //政府价格
        price_guiding: "", //指导价格
        isEdit: false,
      };
      if (this.type == "product") {
        obj.name = "";
      } else {
        obj.sku = "";
      }
      this.tableData.push(obj);
    },
    onSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.tableData.length == 0) return this.$message.warning("请添加产品！");
          if (this.type == "product") {
            this.ruleForm.plan_type = 1;
          } else {
            this.ruleForm.plan_type = 2;
          }
          let { name, plan_type, run_type, crawl_type } = this.ruleForm;
          let params = {
            token: this.getToken,
            name,
            plan_type,
            run_type,
            console_product_list: this.tableData,
            crawl_type,
          };
          let url;
          if (this.edit_id == 0) {
            url = this.consoleplanCreate;
          } else {
            params.id = this.edit_id;
            url = this.consoleproductEdit;
          }
          url(params).then(({ data }) => {
            if (data.code == 1) {
              this.$message.success(this.edit_id == 0 ? "添加成功！" : "修改成功！");
              this.handleClose();
              this.$emit("init");
            } else {
              this.$message.error(data.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose () {
      this.tableData = [];
      this.dialogVisible = false;
      this.$refs.ruleForm.resetFields();
      this.ruleForm = {
        name: "",
        plan_type: 1,
        run_type: "1",
        crawl_type: "1",
      };
      this.edit_id = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  ::v-deep .el-table--border th.el-table__cell {
    background-color: #f8f9fe;
  }
  height: 450px;
  .form {
    margin: 0 40px;
  }
  .table {
    & > p {
      margin: 20px 0;
      color: #999;
    }
  }
  .subtitle {
    margin-bottom: 35px;
    display: flex;
    align-items: center;
    .btn {
      margin-left: 40px;
      display: flex;
      justify-content: space-between;
      flex: 1;
    }
    h4 {
      padding-left: 20px;
      line-height: 18px;
      position: relative;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 2px;
        background: #2448ff;
      }
    }
  }
}
.w400 {
  width: 400px;
}
.link {
  a {
    margin: 0 8px;
  }
}
</style>